module.exports = __webpack_public_path__ + "img/forgotpass.12851cf7.svg";